import { HabitSchedule, Timestamp } from '@griply/types';
import { addWeeks } from 'date-fns';

import { isBetween } from './lib/date-fns';
import { getOccurrences } from './schedules/get-occurrences';

export type GetTimeframeOccurrencesOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export type TimeframeOccurrences = {
  /** The padded range — the month view renders occurrences either side of the timeframe. */
  occurrences: Timestamp[];
  /** Only the ones inside the asked-for range. */
  timeframeOccurrences: Timestamp[];
};

// Padding either side, so a month grid can show the days that spill out of the timeframe.
const PADDING_WEEKS = 3;

export const getTimeframeOccurrences = (
  schedules: HabitSchedule[],
  { startDate, endDate }: GetTimeframeOccurrencesOptions,
): TimeframeOccurrences => {
  const occurrences = getOccurrences(schedules, {
    startDate: addWeeks(startDate, -PADDING_WEEKS),
    endDate: addWeeks(endDate, PADDING_WEEKS),
  });

  return {
    occurrences,
    timeframeOccurrences: occurrences.filter((occurrence) =>
      isBetween(occurrence, startDate, endDate),
    ),
  };
};
